// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".help-dropdown--VTx0r{height:64px}.help-dropdown--VTx0r .help-dropdown-toggle--SZqo_{padding-top:13px;padding-bottom:13px}.help-dropdown--VTx0r .dropdown-menu{max-width:300px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"help-dropdown": "help-dropdown--VTx0r",
	"help-dropdown-toggle": "help-dropdown-toggle--SZqo_"
};
export default ___CSS_LOADER_EXPORT___;
